export default "__VITE_ASSET__nhNZa1Xm__"